<template>
    <div>
        <header-page
                @goToFilteredArticlePage="null"
        ></header-page>
        <div
                v-if="rubrics && transformArticles"
                class="body_zone separator-t-g2 p-t-16 p-r-20 p-l-20 m-b-150"
        >
            <div class="row">
                <div class="col-md-12 col-lg-6 col-xl-6 col-xxl-6 p-8">
                    <div class="css_pageTitle2">Рубрики</div>
                    <div class="table_zone table-responsive">
                        <table class="table table-striped table-sm table-hover">
                            <thead>
                            <tr>
                                <th scope="col">id</th>
                                <th scope="col">Название</th>
                                <th scope="col">Изображение</th>
                                <th scope="col">Статус</th>
                                <th scope="col">Дейсвтие</th>
                            </tr>
                            </thead>
                            <tbody>
                            <rubric-row-item
                                    v-for="rubric in rubrics"
                                    :key="rubric.id"
                                    :rubric="rubric"
                                    @enabled-rubric="enabledRubric"
                                    @delete-rubric="deleteRubric"
                                    @edit-rubric="editRubric"
                            ></rubric-row-item>
                            </tbody>
                        </table>
                    </div>
                    <button
                            @click="createRubric"
                            class="btn btn-success btn-sm w-100 m-t-16"
                    >Создать рубрику</button>
                </div>
                <div class="col-md-12 col-lg-6 col-xl-6 col-xxl-6 p-8">
                    <div class="css_pageTitle2">Статьи</div>
                    <div class="table_zone table-responsive">
                        <table class="table table-striped table-sm table-responsive table-hover">
                            <thead>
                            <tr>
                                <th scope="col">Название</th>
                                <th scope="col" class="text-wrap" style="width: 6rem">id Рубрики</th>
                                <th scope="col">Язык</th>
                                <th scope="col">Статус</th>
                                <th scope="col">Дейсвтия</th>
                            </tr>
                            </thead>
                            <tbody>
                                <article-row-item
                                        v-for="article in transformArticles"
                                        :key="article.id"
                                        :article="article"
                                        @delete-article="deleteArticle"
                                        @edit-article="editArticle"
                                ></article-row-item>
                            </tbody>
                        </table>
                    </div>
                    <button
                            @click="createArticle"
                            class="btn btn-success btn-sm w-100 m-t-16"
                    >Создать статью</button>
                </div>
            </div>

            <rubric-edit
                    :used-rubric="usedRubric"
                    v-if="usedRubric.editable"
                    @save-edit-rubric="saveEditRubric"
                    @close-edit-rubric="closeEditRubric"
            ></rubric-edit>
            <article-edit
                    :used-article="usedArticle"
                    v-if="usedArticle.editable"
                    @save-edit-article="saveEditArticle"
            ></article-edit>
        </div>
    </div>
</template>

<script>
import { reactive } from "vue";

import HeaderPage from "../../shared/components/HeaderPage";
import RubricRowItem from "./components/RubricRowItem";
import RubricEdit from "./components/RubricEdit";
import ArticleRowItem from "./components/ArticleRowItem";
import ArticleEdit from "./components/ArticleEdit";

import {storeToRefs} from "pinia";

import {useRubricArticleStore, useStatesStorage} from "../../stores/store";
import {deleteRubricAJ, deleteArticleAJ} from "../../api/http";

import {DEFAULT_LANGUAGE_CODE} from "../../shared/constants/consts";
import {InitStates} from "../../shared/services/init";
import {getArticleById, getRubricById} from "../../shared/services/util";
import {prepareSaveRubricAJ} from "./services/util";

export default {
    setup() {
        InitStates();

        const rubricArticleStore = useRubricArticleStore();
        const { rubrics, articles, rubric_articles: transformArticles } = storeToRefs(rubricArticleStore);

        //console.log('rubric_id', rubric_id.value, 'rubric_articles', transformArticles.value);

        const statesStorage = useStatesStorage();
        const { viewStates } = storeToRefs(statesStorage);

        /*const transformArticles = computed(() => {
            return getTransformArticles(articles.value, null, CONST_ADMIN_PATH)
        });*/

        const usedRubric = reactive({
            id: null,
            name: '',
            image_link: '',
            enabled: 0,
            editable: false
        });

        const usedArticle = reactive({
            id: null,
            date: null,
            rubric_id: null,
            content_lang: {},
            link: null,
            current_edit_lang: DEFAULT_LANGUAGE_CODE,
            editable: false
        });

        //rubric
        const enabledRubric = (rubric_id) => {
            if(viewStates.save_in_process) {
                alert('Производится сохранение');
                return;
            }

            let rubricObj = getRubricById(rubrics.value, rubric_id);
            rubricObj.enabled = rubricObj.enabled == 1 ? 0 : 1;

            prepareSaveRubricAJ(rubricObj);
        };

        const editRubric = (rubric_id) => {
            const rubricObj = getRubricById(rubrics.value, rubric_id);

            if(rubricObj == null) {
                alert('Не удалось найти рубрику');
            }

            usedRubric.id = rubricObj.id;
            usedRubric.name = rubricObj.name;
            usedRubric.image_link = rubricObj.image_link;
            usedRubric.enabled = rubricObj.enabled;
            usedRubric.editable = true;

            usedArticle.editable = false;
        };

        const deleteRubric = (rubric_id) => {
            if(viewStates.save_in_process) {
                alert('Производится удаление');
                return;
            }

            const confirmDeleteRubric = confirm('Вы уверены что хотите удалить рубирку?')

            if(confirmDeleteRubric) {
                viewStates.save_in_process = true;

                usedRubric.editable = false;

                deleteRubricAJ(rubric_id).then(r => {
                  if(r.ok)
                  {
                      alert('Удаление успешное');

                      rubrics.value = rubrics.value.filter(r => parseInt(r.id) !== parseInt(rubric_id));

                      viewStates.save_in_process = false;

                      return r;
                  }
                  else
                  {
                      throw new Error(r.error);
                  }
                }).catch((error) => {
                  alert(error)
                  return false;
                });
            }
        };

        const createRubric = () => {
            usedRubric.id = null;
            usedRubric.name = '';
            usedRubric.image_link = '';
            usedRubric.enabled = 0;
            usedRubric.editable = true;

            usedArticle.editable = false;
        };

        const saveEditRubric = () => {
            usedRubric.editable = false;
        }

        const closeEditRubric = () => {
            usedRubric.editable = false;
        }

        //article
        const editArticle = ({rubric_id, article_id}) => {
            const articleObj = getArticleById(articles.value, rubric_id, article_id);

            if(articleObj == null) {
                alert('Не удалось найти статью');
            }

            const first_lang = Object.keys(articleObj.content_lang)[0];

            usedArticle.id = articleObj.id;
            usedArticle.rubric_id = articleObj.rubric_id;
            usedArticle.content_lang = articleObj.content_lang;
            usedArticle.link = articleObj.link;
            usedArticle.date = articleObj.date;
            usedArticle.current_edit_lang = first_lang;
            usedArticle.editable = true;

            usedRubric.editable = false;
        };

        const deleteArticle = ({rubric_id, article_id}) => {
            if(viewStates.save_in_process) {
                alert('Производится удаление');
                return;
            }

            const confirmDeleteArticle = confirm('Вы уверены что хотите удалить статью?')

            usedArticle.editable = false;

            if(confirmDeleteArticle) {
                viewStates.save_in_process = true;

                deleteArticleAJ(rubric_id, article_id).then(r => {
                  viewStates.save_in_process = false;

                  if(r.ok)
                  {
                    alert('Удаление успешное');

                    articles.value = articles.value.filter(a => parseInt(a.id) !== parseInt(article_id));

                    return r;
                  }
                  else
                  {
                    throw new Error(r.error);
                  }
                }).catch((error) => {
                  alert(error)
                  return false;
                });
            }
        };

        const createArticle = () => {
            const first_rubric_id = Object.values(rubrics.value)[0].id;

            usedArticle.id = null;
            usedArticle.rubric_id = first_rubric_id;
            usedArticle.content_lang = null;
            usedArticle.link = null;
            usedArticle.date = null;
            usedArticle.current_edit_lang = DEFAULT_LANGUAGE_CODE;
            usedArticle.editable = true;

            usedRubric.editable = false;
        };

        const saveEditArticle = () => {
            usedArticle.editable = false;
        }

        return {
            rubrics,
            transformArticles,

            usedRubric,
            usedArticle,

            createRubric,
            enabledRubric,
            editRubric,
            deleteRubric,
            saveEditRubric,
            closeEditRubric,

            createArticle,
            editArticle,
            deleteArticle,
            saveEditArticle
        }
    },
    components: {HeaderPage, RubricRowItem, RubricEdit, ArticleRowItem, ArticleEdit}
}
</script>

<style scoped>
    .table_zone{
        max-height: 300px;
    }
</style>